/* 🤖 this file was generated by script */
export const wiconTextInput = {
  name: 'text_input',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7H5.2c-1.12 0-1.68 0-2.1.22a2 2 0 00-.88.87C2 8.52 2 9.08 2 10.2v3.6c0 1.12 0 1.68.22 2.1.19.38.5.69.87.88.43.22.99.22 2.11.22H13m4-10h1.8c1.12 0 1.68 0 2.1.22.38.19.69.5.88.87.22.43.22.99.22 2.11v3.6c0 1.12 0 1.68-.22 2.1a2 2 0 01-.87.88c-.43.22-.99.22-2.11.22H17m0 4V3m2.5 0h-5m5 18h-5"/></svg>`,
};
